import { ref } from 'vue'

export const conversionRateBus = ref<number>(1)
